import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Typography = (props) => {
  const {
    className: classNameProp,
    component: componentProp,
    ...other
  } = props;

  const className = classNames(classNameProp);
  const Component = componentProp || 'p';
  return <Component className={className} {...other} />;
};

Typography.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

Typography.defaultProps = {
  className: '',
  component: 'p',
  children: null,
};

export default Typography;
